import { AnnotationRecord } from './annotationsFromNgx';

export interface AnnotationDBRecord {
  organizationId: string;
  userId: string;
  direntId: string;
  record: AnnotationRecord;
  annotationId: string;
}
